import React, { useEffect, useState } from 'react';
import PortalOverlay from '@/components/PortalOverlay';

/**
 * iter382: our own confirm dialog.
 *
 * `window.confirm` renders the browser's own buttons, which say "OK" and
 * "Cancel" in English however Icelandic the rest of the app is. Call sites use
 * it exactly like the old one:
 *
 *   if (!(await confirmDialog('Eyða línunni?'))) return;
 *   if (!(await confirmDialog({ message: '...', confirmLabel: 'Eyða' }))) return;
 */
let openConfirm = null;

export const confirmDialog = (options) => {
  const opts = typeof options === 'string' ? { message: options } : (options || {});
  if (!openConfirm) return Promise.resolve(window.confirm(opts.message || ''));
  return new Promise((resolve) => openConfirm(opts, resolve));
};

export const ConfirmDialogHost = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    openConfirm = (opts, resolve) => setState({ opts, resolve });
    return () => { openConfirm = null; };
  }, []);

  if (!state) return null;
  const { opts, resolve } = state;
  const finish = (answer) => { setState(null); resolve(answer); };
  const text = String(opts.message || '');
  const [first, ...rest] = text.split('\n\n');

  return (
    <PortalOverlay open onClose={() => finish(false)}>
      <div
        className="w-full max-w-md rounded-lg border border-border bg-card p-5 space-y-3"
        data-testid="confirm-dialog"
        role="alertdialog"
        aria-modal="true"
      >
        {opts.title && (
          <h3 className="text-base font-medium text-foreground">{opts.title}</h3>
        )}
        <p className="text-sm text-foreground whitespace-pre-line" data-testid="confirm-dialog-message">
          {first}
        </p>
        {rest.length > 0 && (
          <p className="text-xs text-foreground-muted whitespace-pre-line">
            {rest.join('\n\n')}
          </p>
        )}
        <div className="flex justify-end gap-2 pt-1">
          <button
            className="btn btn-secondary text-sm"
            onClick={() => finish(false)}
            data-testid="confirm-dialog-cancel"
          >
            {opts.cancelLabel || 'Hætta við'}
          </button>
          <button
            className={`btn text-sm ${opts.danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={() => finish(true)}
            data-testid="confirm-dialog-confirm"
            autoFocus
          >
            {opts.confirmLabel || 'Halda áfram'}
          </button>
        </div>
      </div>
    </PortalOverlay>
  );
};

export default ConfirmDialogHost;
